module.exports = __webpack_public_path__ + "static/media/circle-progress.870baa3a.svg";